
const additionalResourcesService = {
    /**
     * Returns the additional resources found on the parentTest and the current assessment
     */
    getAdditionalResources(settings, assessment, parentTest) {
        const parentAssessment = parentTest?.assessment ? parentTest.assessment : undefined;
        // eslint-disable-next-line camelcase
        const sebAdditionalResources = settings.values?.lockdown_additional_resources
            ? JSON.parse(settings.values.lockdown_additional_resources)
            : [];
        const questionSetAdditionalResources = assessment.additionalResources || [];
        const parentQuestionSetAdditionalResources = parentAssessment?.additionalResources ? parentAssessment.additionalResources : [];
        return parentQuestionSetAdditionalResources
            .concat(questionSetAdditionalResources)
            .concat(sebAdditionalResources)
            .filter((res) => {
                return res.type !== 'embeddedLink' && res.type !== 'audio';
            });
    },
};

export default additionalResourcesService;
